
(function() {
    var afterLoadListeners = [ ];

    /** Registers a function to be called after the SLC variable is setup */
    window.slcAfterLoad = function(listener) {
        if(loaded) {
            listener(window.SLC);
        } else {
            afterLoadListeners.push(listener);
        }
    }

    /** Calls the after load listeners */
    var loaded = false;
    window.slcNotifyLoaded = function() {
        loaded = true;
        for(var i=0; i < afterLoadListeners.length; i++) {
            afterLoadListeners[i](window.SLC);
        }

        delete afterLoadListeners;
    }

})();
